function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Purpose: Execute RustScript AST against runtime context.
 */

function ast_execute(ast, context) {
  if (!ast || _typeof(ast) !== 'object' || !context || _typeof(context) !== 'object') {
    return false;
  }
  if (!context.opcodes || _typeof(context.opcodes) !== 'object') {
    return false;
  }
  var walk = [{
    node: ast,
    visited: false
  }];
  var values = [];
  while (walk.length > 0) {
    var frame = walk.pop();
    var node = frame.node;
    if (!node || _typeof(node) !== 'object' || typeof node.op !== 'string' || node.op.length === 0) {
      return false;
    }
    var op = node.op;
    if (!frame.visited) {
      walk.push({
        node: node,
        visited: true
      });
      if (op === 'NOT') {
        if (!Array.isArray(node.args) || node.args.length !== 1) {
          return false;
        }
        walk.push({
          node: node.args[0],
          visited: false
        });
        continue;
      }
      if (op === 'AND' || op === 'OR' || op === 'THEN') {
        if (!Array.isArray(node.args) || node.args.length < 2) {
          return false;
        }
        for (var i = node.args.length - 1; i >= 0; i -= 1) {
          walk.push({
            node: node.args[i],
            visited: false
          });
        }
        continue;
      }
      continue;
    }
    if (op === 'NOT') {
      if (values.length < 1) {
        return false;
      }
      var a = values.pop();
      values.push(!a);
      continue;
    }
    if (op === 'AND' || op === 'OR' || op === 'THEN') {
      var argCount = Array.isArray(node.args) ? node.args.length : 0;
      if (values.length < argCount) {
        return false;
      }
      var start = values.length - argCount;
      if (op === 'OR') {
        var result = false;
        for (var _i = start; _i < values.length; _i += 1) {
          if (values[_i] === true) {
            result = true;
            break;
          }
        }
        values.length = start;
        values.push(result);
        continue;
      }
      var allTrue = true;
      for (var _i2 = start; _i2 < values.length; _i2 += 1) {
        if (values[_i2] !== true) {
          allTrue = false;
          break;
        }
      }
      values.length = start;
      values.push(allTrue);
      continue;
    }
    var key = op.toLowerCase();
    var handler = context.opcodes[key];
    if (typeof handler !== 'function') {
      return false;
    }
    values.push(handler(node, context) === true);
  }
  if (values.length !== 1) {
    return false;
  }
  return values[0] === true;
}
module.exports = ast_execute;